import CompleteRegistration, { CompleteRegistrationProps } from '@/modules/session/CompleteRegistration'
import { useLocalSearchParams } from 'expo-router'

export default function CompleteRegistrationPage() {
  const { code, provider } = useLocalSearchParams<CompleteRegistrationProps>()

  return (
    <CompleteRegistration code={code} provider={provider} />
  )
}
